<spinner id="annotationSpinner" [isRunning]="spinnerIsRunning"></spinner>
<h1 class="docviewer-title">{{originalname}}</h1>

<mat-card *ngIf="error" class="docviewer-error-card" role="alert">
  <h2 class="docviewer-error-title">Error Creating a Viewing Session</h2>
  <p class="docviewer-error-text">
    There was a problem creating a viewing session for displaying the document:
  </p>
  <pre class="docviewer-error-message">
    {{error.message}}
  </pre>
</mat-card>

<ng-template [ngIf]="!error">
  <app-prizmdoc-viewer-wrapper [viewingSessionId]="viewingSessionId" (viewerControl)="setViewerControl($event)" width="100%" height="700px" (annotationsChanged)="onAnnotationsChanged($event)"></app-prizmdoc-viewer-wrapper>
  <br>
  <div class="docviewer-actions-panel">
      <button mat-button id="showErrorMessage" (click)="showErrorMessage()" class="docviewer-hidden-trigger">errorMessage</button>
      <button mat-button id="showSuccessMessage" (click)="showSuccessMessage()" class="docviewer-hidden-trigger">successMessage</button>
      <button mat-button id="toggleSpinner" (click)="toggleSpinner()" class="docviewer-hidden-trigger">toggleSpinner</button>
      <div class="save-button-wrapper" [class.save-button-wrapper-enabled]="saveButtonEnabled">
        <button mat-raised-button id="saveScrimsAnnotation" class="docviewer-action-button docviewer-save-button" [disabled]="!saveButtonEnabled" (click)="disableSaveButton()">Save</button>
      </div>
      <button mat-raised-button class="docviewer-action-button docviewer-return-button" (click)="return()">Return</button>
  </div>
</ng-template>
